import { POST_FEELINGS } from '../constants/createPost';

const normalizeFeelingText = (value: string): string =>
  value.trim().toLowerCase();

/**
 * Resolves the title returned by post APIs back to a composer feeling key.
 * Complete keys win before the legacy substring fallback so overlapping keys
 * such as `light`/`lighter` and `proud`/`proudOfMyself` round-trip correctly.
 */
export const parsePostFeelingTitle = (
  title?: string | null,
): string | null => {
  if (!title || typeof title !== 'string') return null;
  const trimmed = title.trim();
  if (!trimmed) return null;

  const normalizedTitle = normalizeFeelingText(trimmed);
  const normalizedFeelings = POST_FEELINGS.map(feeling => ({
    ...feeling,
    normalizedKey: normalizeFeelingText(feeling.key),
  }));

  const completeMatch = normalizedFeelings.find(
    feeling =>
      normalizedTitle === feeling.normalizedKey ||
      normalizedTitle.endsWith(` ${feeling.normalizedKey}`),
  );
  if (completeMatch) return completeMatch.key;

  const substringMatch = [...normalizedFeelings]
    .sort((left, right) => right.normalizedKey.length - left.normalizedKey.length)
    .find(feeling => normalizedTitle.includes(feeling.normalizedKey));

  return substringMatch?.key ?? trimmed;
};
